// ข้อมูลกลางของระบบสมาชิก ใช้ร่วมกันทุก React root (navbar / sidebar / root / memberhub)
// MemberHub เป็นตัวโหลดข้อมูล (mainsetting, theme, checkpoint) แล้วอัปเดตเข้ามาที่นี่
import { useEffect, useState } from 'react';

const state = {
  setting: null,          // ผลลัพธ์ /api/v1/mainsetting ทั้งก้อน
  theme: null,            // ThmeseV จาก /api/v1/getthemesv
  user: { loginstate: false },
};
const listeners = new Set();

export const getStore = () => state;

export function setStore(patch) {
  Object.assign(state, patch);
  listeners.forEach((fn) => fn(state));
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function useStore() {
  const [, force] = useState(0);
  useEffect(() => subscribe(() => force((n) => n + 1)), []);
  return state;
}

// ค่าที่ใช้บ่อยจาก mainsetting
export const settingOf = (s) => {
  const st = s && s.tblsetting && s.tblsetting[0];
  const clean = (v) => (v && v !== 'null' ? v : '');
  const selflink = clean(((s && s.message) || []).find((m) => m && m.column === 'selflink')?.value);
  let host = '';
  try { host = selflink ? new URL(selflink).hostname.replace(/^www\./, '').replace(/\.[a-z.]+$/i, '') : ''; } catch (e) { /* ignore */ }
  return {
    // ชื่อเว็บ: tblsetting.Description -> tblsetting.title -> โดเมนจาก selflink
    siteName: clean(st && st.Description) || clean(st && st.title) || host,
    logo: clean(st && st.imglogo),
    title: clean(st && st.title),
    linelink: clean(((s && s.message) || []).find((m) => m && m.column === 'linelink')?.value) || clean(s && s.message && s.message[1] && s.message[1].value),
    // [2026-10-30] ค่าจาก BO › ตั้งค่า WEBSITE (tblsetting / tblmainsetting) — เดิมยังไม่ได้ใช้
    whatsapp: clean(((s && s.message) || []).find((m) => m && m.column === 'whatsapplink')?.value),
    favicon: clean((st && st.favicon) || (s && s.favicon)),
    description: clean(st && st.sitedescription),
    keywords: clean(st && st.keywords),
    googletag: clean(st && st.googletag),
    textslide: clean(st && st.textslide),
    minwithdraw: clean(st && st.minwithdraw),
    maxwithdraw: clean(st && st.maxwithdraw),
    wheelOn: !!(s && s.tblwheelsetting && s.tblwheelsetting[0] && s.tblwheelsetting[0].status === 1),
    cardOn: !!(s && s.tblcardminigamesetting && s.tblcardminigamesetting[0] && s.tblcardminigamesetting[0].status === 1),
  };
};

// เปิดหน้าสมาชิก: deposit | withdraw | affiliate | checkin | wheel | cardgame | promotion
//                  cashback | rebate | toprank | redeem | statement | profile
export function openPanel(name) {
  window.dispatchEvent(new CustomEvent('memberhub:open', { detail: name }));
}
export function refreshUser() {
  window.dispatchEvent(new Event('memberhub:refresh'));
}
export function logout() {
  localStorage.removeItem('auth_token');
  window.location.href = '/';
}
// เปิดหน้าต่าง login เดิมของธีม (bootstrap modal #loginmodal)
export function openLogin() {
  const $ = window.jQuery || window.$;
  if ($ && $('#loginmodal').length) $('#loginmodal').modal('show');
  else window.location.href = '/signin';
}
